import {USER_LOAD_CFG_ITEM} from '~/frontend/src/constants';
import {StoreState, AppDispatch, Thunk} from '~/frontend/src/store';
import loadData from '~/frontend/src/actions/data/loadData';
import cloneUser from '~/frontend/src/actions/user/cloneUser';


export type LoadCfgItemAction = {
    type : typeof USER_LOAD_CFG_ITEM;
    componentUid : string;
}

/**
 * @memberOf! Actions
 *
 * @return {}
 */
const loadCfgItem = ( componentUid : string = 'global' ) : Thunk<Promise<boolean>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<boolean> => {
    dispatch( {
        type: USER_LOAD_CFG_ITEM,
        componentUid
    } );

    const user = getState().session.user;

    let retVal = false;

    if ( user ) {
        const dataContext = user.itemContext,
              result  = await dispatch( loadData( 'user/reloadItem', dataContext, componentUid, 'userLoadCfgItem', 'CFG', {} ) );

        if ( result ) {
            dispatch( cloneUser() );

            retVal = true;
        }
    }

    return retVal;
}

export type LoadCfgItem = typeof loadCfgItem;

export default loadCfgItem;
